"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Small;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _AbstractTextElement = _interopRequireDefault(require("./AbstractTextElement"));

function Small(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_AbstractTextElement.default, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-microcopy', className)
  }));
}

Small.propTypes = _AbstractTextElement.default.propTypes;
Small.defaultProps = (0, _extends2.default)({}, _AbstractTextElement.default.defaultProps, {
  tagName: 'small'
});
Small.displayName = 'Small';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/elements/Small.js
// module id = 46
// module chunks = 209 210 211 212